import React, { useState, useEffect, FC } from 'react';
import SummarySkeleton from 'components/commercetools-ui/atoms/skeleton/order-summary-skeleton';
import useClassNames from 'helpers/hooks/useClassNames';
import { useCart } from 'frontastic';
import Costs from './components/costs';
import DiscountForm from './components/discount-form';
import PaymentMethods from './components/payment-methods';
import { OrderSummaryProps } from '../order-summary/types';
import Link from 'components/commercetools-ui/atoms/link';

const OrderPaymentSection: FC<OrderSummaryProps> = ({
  className,
  paymentMethods = [],
  button,
  dataReference = 'cart',
  classNames,
  order,
  isFreeDeliveryBannerRequired = true,
  ...props
}) => {
  const { isEmpty, data } = useCart();
  const [isLoading, setIsLoading] = useState(true);

  // const infoContainerClassName = useClassNames(['border-t border-neutral-400 bg-white', classNames?.infoContainer]);
  const infoContainerClassName = useClassNames(['bg-white', classNames?.infoContainer]);

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timeoutID);
  }, []);

  if (!data && isLoading) return <SummarySkeleton />;

  return (
    <div className={className} {...props}>
      {!isEmpty && !order && dataReference !== 'order' && <DiscountForm className={classNames?.applyDiscountButton} />}
      <div className={infoContainerClassName}>
        <Costs
          order={order}
          dataReference={dataReference}
          totalAmountClassName={classNames?.totalAmount}
          subCostsContainerClassName={classNames?.subCostsContainer}
          subCostClassName={classNames?.subCost}
          isFreeDeliveryBannerRequired={isFreeDeliveryBannerRequired}
        />

        {button}

        {paymentMethods.length > 0 && <PaymentMethods paymentMethods={paymentMethods} />}
      </div>
    </div>
  );
};

export default OrderPaymentSection;
